import { AppStateType } from '@lib/core/service/types/appStateType';

/**
 * @returns The base route of the application.
 */
export const selectRouteBasename = (state: AppStateType, defaultValue = ''): string =>
  state?.routes?.basename || defaultValue;
